<template>
  <el-container class="shopList">
    <el-header class="box add bb df">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品收货管理</el-breadcrumb-item>
        <el-breadcrumb-item>收货列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="medium" type="primary" @click="add">新增收货</el-button>
    </el-header>
    <el-main class="p15 pt0">
      <el-form :inline="true" class="demo-form-inline">
        <div class="df" style="margin-top: 20px">
          <el-form-item size="medium" class="mr10" style="flex: 0 0 15%">
            <el-input
              placeholder="收货订单号"
              v-model="page.receipt_sn"
              clearable
              class="input-with-select"
              @clear="onSubmit(page.shipping_sn)"
            >
            </el-input>
          </el-form-item>
          <el-form-item size="medium" class="mr10" style="flex: 0 0 15%">
            <el-input
              placeholder="发货公司"
              v-model="page.consignee_company_name"
              clearable
              class="input-with-select"
              @clear="onSubmit(page.goods_name)"
            >
            </el-input>
          </el-form-item>
          <el-form-item size="medium" class="mr10" style="flex: 0 0 15%">
            <el-input
              placeholder="商品名称"
              v-model="page.goods_name"
              clearable
              class="input-with-select"
              @clear="onSubmit(page.goods_name)"
            >
            </el-input>
          </el-form-item>
          <el-form-item size="medium" class="mr10" style="flex: 0 0 15%">
            <el-input
              placeholder="商品品码"
              v-model="page.gtin"
              clearable
              class="input-with-select"
              @clear="onSubmit(page.goods_name)"
            >
            </el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="medium"
            @click="onSubmit"
            class="mr10"
            style="height: 34px; border: none !important; margin-top: 1px"
            >查询</el-button
          >
          <el-upload
            class="upload"
            action="#"
            :multiple="false"
            ref="upload"
            accept=".xlsx"
            :limit="1"
            :show-file-list="false"
            :before-upload="beforeUpload"
            style="float: right"
          >
            <el-button
              style="height: 34px; border: none; margin-top: 1px"
              class="mr10"
              type="success"
              size="medium"
              @click="batchAdd"
              >批量导入</el-button
            >
          </el-upload>

          <el-button
            style="height: 34px; border: none; margin-top: 1px"
            size="medium"
            type="warning"
            @click="downloadInfo(1)"
            >下载模板</el-button
          >
        </div>
        <div class="df aic">
          <el-form-item style="margin-right: 0">
            <el-date-picker
              type="date"
              placeholder="开始日期"
              v-model="add_time"
              :picker-options="pickerOptionsStart"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="change(1, add_time)"
            ></el-date-picker>
          </el-form-item>
          <div class="df aic jcc" style="flex: 0 0 40px; margin-bottom: 20px">
            至
          </div>
          <el-form-item class="mr10">
            <el-date-picker
              type="date"
              placeholder="结束日期"
              v-model="end_time"
              :picker-options="pickerOptionsEnd"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="change(2, end_time)"
            ></el-date-picker>
          </el-form-item>
          <el-button
            size="medium"
            class="mr10"
            type="warning"
            style="height: 38px; border: none; margin-bottom: 20px"
            @click="exportData(1)"
            >导出数据</el-button
          >
          <el-upload
            class="upload"
            action="#"
            :multiple="false"
            ref="upload"
            accept=".xlsx"
            :limit="1"
            :show-file-list="false"
            :before-upload="beforeUpload1"
            style="float: right"
          >
            <el-button
              type="primary"
              size="medium"
              style="height: 34px; margin-bottom: 20px; border: none"
              class="mr10"
              >按导出数据批量导入</el-button
            >
          </el-upload>
          <div style="margin-bottom: 20px; margin-left: 50px">
            <div style="color: #909399">
              货物总价:
              <span style="color: #0081ff; font-weight: bold">{{
                totalPrices
              }}</span>
              元
            </div>
          </div>
        </div>
      </el-form>

      <div class="box list">
        <el-table border :data="tableData" style="width: 100%" id="out-table">
          <el-table-column min-width="80" type="expand" label="详情">
            <template slot-scope="props">
              <el-form
                label-position="left"
                inline
                class="demo-table-expand pl30 pr30"
              >
                <el-form-item label="商品重量">
                  <h5>
                    {{
                      props.row.goods_weight
                        ? props.row.goods_weight + "kg"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="单个重量">
                  <h5>
                    {{
                      props.row.goods_unit
                        ? props.row.goods_unit + "kg"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品总数">
                  <h5>
                    {{
                      props.row.goods_sum
                        ? props.row.goods_sum + "件"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品件数">
                  <h5>
                    {{
                      props.row.goods_number
                        ? props.row.goods_number + "件"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>
                <el-form-item label="货品总价">
                  <h5>
                    {{
                      props.row.goods_total_price
                        ? props.row.goods_total_price + "元"
                        : "未填写"
                    }}
                  </h5>
                </el-form-item>

                <div>
                  <el-form-item label="运输车辆" class="form-item-half">
                    <h5>
                      {{
                        props.row.car_number ? props.row.car_number : "未填写"
                      }}
                    </h5>
                  </el-form-item>
                  <el-form-item label="收货人姓名" class="form-item-half">
                    <h5>
                      {{
                        props.row.created_name
                          ? props.row.created_name
                          : "未填写"
                      }}
                    </h5>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            prop="receipt_sn"
            min-width="120"
            :show-overflow-tooltip="true"
            label="收货订单号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="goods_name"
            min-width="120"
            :show-overflow-tooltip="true"
            label="商品名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            min-width="120"
            :show-overflow-tooltip="true"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'finished'" style="color: green"
                >已完成</span
              >
              <span v-if="scope.row.status === 'received'" style="color: orange"
                >已收货</span
              >
              <span v-if="scope.row.status === 'pending'" style="color: blue"
                >待收货</span
              >
              <span v-if="scope.row.status === 'invalid'" style="color: red"
                >已作废</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="receive_time"
            min-width="100"
            :show-overflow-tooltip="true"
            label="收货时间"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="gtin"
            min-width="120"
            :show-overflow-tooltip="true"
            label="商品品码"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="batch_number"
            min-width="120"
            :show-overflow-tooltip="true"
            label="批次号"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="car_number"
            min-width="120"
            :show-overflow-tooltip="true"
            label="运输车辆"
            align="center"
          >
          </el-table-column> -->

          <el-table-column
            prop="consigner_company_name"
            min-width="160"
            :show-overflow-tooltip="true"
            label="发货公司"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="goods_total_price"
            min-width="160"
            :show-overflow-tooltip="true"
            label="总价(元)"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="unitWeight"
            min-width="160"
            :show-overflow-tooltip="true"
            label="数量"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="created_name"
            min-width="160"
            :show-overflow-tooltip="true"
            label="收货人姓名"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            prop="qualification"
            min-width="160"
            :show-overflow-tooltip="true"
            label="相关资证"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showImage(scope.row)"
                class="general_bgc general_border cfff"
                >查看图片</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="real_pics"
            min-width="160"
            :show-overflow-tooltip="true"
            label="发货实景"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="showImage1(scope.row)"
                class="general_bgc general_border cfff"
                >查看图片</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="i-page fr disib mt20">
          <el-pagination
            background
            :page-size="10"
            layout="total,prev, pager, next"
            :total="total"
            :current-page="currentPage"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog :visible.sync="showViewer">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
      <el-dialog :visible.sync="showResult" width="60%" title="导入确认">
        <div style="height: 800px; flex-direction: column" class="df aic">
          <div
            style="flex: 1; height: 0; overflow-y: scroll; width: 100%"
            class="result-box"
          >
            <div style="">
              <div class="df aic">
                <h2 style="margin: 0px 0 10px">
                  该Excel中与该企业不存在供销关系的企业有<span
                    style="color: red"
                    >{{ supplyNotExist.length }}</span
                  >条
                </h2>
              </div>
              <el-table :data="supplyNotExist" border>
                <el-table-column
                  prop="goods_name"
                  min-width="120"
                  :show-overflow-tooltip="true"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="gtin"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="品码"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="batch_number"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="批次号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="consigner_company_name"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="发货企业"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div class="df aic">
                <h2 style="margin: 20px 0px 10px">
                  该Excel中商品不存在的信息有<span style="color: darkblue">{{
                    goodsExist.length
                  }}</span
                  >条
                </h2>
              </div>
              <el-table :data="goodsExist" border>
                <el-table-column
                  prop="goods_name"
                  min-width="120"
                  :show-overflow-tooltip="true"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="gtin"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="品码"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="batch_number"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="批次号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="consigner_company_name"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="发货企业"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div class="df aic">
                <h2 style="margin: 20px 0 10px">
                  该Excel中商品可导入信息有<span style="color: darkblue">{{
                    infoUpload.length
                  }}</span
                  >条
                </h2>
              </div>
              <el-table
                border
                :data="infoUpload"
                @select="handleChecked"
                @select-all="handleCheckedAll"
                ref="infoTable"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="goods_name"
                  min-width="120"
                  :show-overflow-tooltip="true"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="gtin"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="品码"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="batch_number"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="批次号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="consigner_company_name"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  label="发货企业"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="df aic jcc" style="height: 60px; width: 100%">
            <el-button
              style="height: 34px; border: none; margin-top: 1px"
              class="mr10"
              type="primary"
              size="medium"
              @click="confirmInfo"
              >确认导入({{
                infoUpload.filter((v) => v.checked).length
              }}条)</el-button
            >
            <el-button
              style="height: 34px; border: none; margin-top: 1px"
              class="mr10"
              type="info"
              size="medium"
              @click="showResult = false"
              >&emsp;取消&emsp;</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog title="相关资证" :visible.sync="picDialogVisible">
        <div
          style="
            height: 70vh;
            overflow-y: scroll;
            overflow-x: hidden;
            padding-right: 20px;
          "
          class="modal-body"
        >
          <template v-if="reportList.length > 0">
            <div>
              <el-divider content-position="left">
                <el-tag>资证报告</el-tag>
              </el-divider>
              <el-row :gutter="10">
                <el-col
                  :span="6"
                  v-for="(item, index) in reportList"
                  :key="index"
                >
                  <el-image
                    style="height: 200px"
                    :src="item"
                    :preview-src-list="reportList"
                  ></el-image>
                </el-col>
              </el-row>
            </div>
            <template v-if="quoUpdateList && quoUpdateList.length">
              <el-divider content-position="left">
                <el-tag>历史记录</el-tag>
              </el-divider>
              <el-collapse
                v-model="activeNames"
                style="border-radius: 10px; overflow: hidden"
              >
                <el-collapse-item
                  :name="index"
                  v-for="(item, index) in quoUpdateList"
                  :key="index"
                >
                  <template slot="title">
                    <div
                      class="df aic jcb"
                      style="width: 100%; padding-right: 50px"
                    >
                      <div style="font-weight: bold; font-size: 20px">
                        {{ item.updatedTime.replace("T", " ") }}
                      </div>
                      <div>修改人:{{ item.updatedName }}</div>
                    </div>
                  </template>
                  <div
                    style="
                      background-color: #f8f8f8;
                      padding: 5px;
                      overflow: hidden;
                    "
                  >
                    <el-card
                      class="box-card"
                      v-for="(val, index1) in item.data"
                      :key="index1"
                    >
                      <div
                        slot="header"
                        style="
                          box-sizing: border-box;
                          text-align: left;
                          line-height: 20px;
                          font-size: 16px;
                          font-weight: 600;
                        "
                      >
                        <span>{{ val.title }}</span>
                      </div>
                      <div>
                        <template
                          v-if="val.list.filter((vItem) => !vItem.file).length"
                        >
                          <div class="section-title">资证图片</div>
                          <el-row :gutter="10">
                            <el-col
                              :span="6"
                              v-for="(imageItem, imageIndex) in val.list.filter(
                                (vItem) => !vItem.file
                              )"
                              :key="imageIndex"
                            >
                              <el-image
                                style="height: 200px"
                                :src="imageItem.picUrl"
                                :preview-src-list="
                                  val.list
                                    .filter((vItem) => !vItem.file)
                                    .map((vItem) => vItem.picUrl)
                                "
                              ></el-image>
                            </el-col>
                          </el-row>
                        </template>
                        <template
                          v-if="val.list.filter((vItem) => vItem.file).length"
                        >
                          <div class="section-title">资证文件</div>
                          <div
                            class="df aic file-background"
                            style=""
                            v-for="(fileItem, index2) in val.list.filter(
                              (vItem) => vItem.file
                            )"
                            :key="index2"
                            @click="openFile(index, index1, index2)"
                          >
                            <template v-if="fileItem.name">
                              <img
                                src="./static/word.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="
                                  fileItem.name.includes('.doc') ||
                                  fileItem.name.includes('.docx')
                                "
                              />
                              <img
                                src="./static/pdf.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="fileItem.name.includes('.pdf')"
                              />
                              <img
                                src="./static/excel.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="
                                  fileItem.name.includes('.xls') ||
                                  fileItem.name.includes('.xlsx') ||
                                  fileItem.name.includes('.xlsm') ||
                                  fileItem.name.includes('.xlsb') ||
                                  fileItem.name.includes('.csv')
                                "
                              />
                            </template>
                            <template v-if="fileItem.fileName">
                              <img
                                src="./static/word.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="
                                  fileItem.fileName.includes('.doc') ||
                                  fileItem.fileName.includes('.docx')
                                "
                              />
                              <img
                                src="./static/pdf.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="fileItem.fileName.includes('.pdf')"
                              />
                              <img
                                src="./static/excel.png"
                                style="width: 40px; height: 40px"
                                mode="aspectFit"
                                v-if="
                                  fileItem.fileName.includes('.xls') ||
                                  fileItem.fileName.includes('.xlsx')
                                "
                              />
                            </template>
                            <div
                              class=""
                              style="flex: 1; width: 0; margin-left: 15px"
                            >
                              <div
                                class="ellipsis"
                                style="
                                  white-space: normal;
                                  overflow-wrap: break-word;
                                  word-break: break-word;
                                  hyphens: auto;
                                  font-weight: 600;
                                  font-size: 15px;
                                  line-height: 18px;
                                "
                              >
                                {{
                                  fileItem.name
                                    ? fileItem.name
                                    : fileItem.fileName
                                }}
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </el-card>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </template>
          </template>
          <div v-else>
            <span>暂无</span>
          </div>
        </div>
      </el-dialog>
      <el-dialog title="收货实景" :visible.sync="picDialogVisible1" top="8vh">
        <div v-if="attachList.length > 0">
          <el-divider content-position="left">
            <el-tag type="success">收货实景</el-tag>
          </el-divider>
          <el-row :gutter="10">
            <el-col :span="6" v-for="(item, index) in attachList" :key="index">
              <el-image
                style="height: 200px"
                :src="item"
                :preview-src-list="attachList"
              ></el-image>
            </el-col>
          </el-row>
        </div>
        <div v-else>
          <span>暂无</span>
        </div>
      </el-dialog>
    </el-main>
    <el-image-viewer
      style="z-index: 9999"
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[url]"
    />
  </el-container>
</template>
<script>
import axios from "@/util/api";
import api from "@/util/extra-api";
import { local } from "@/util/util";
import { mapState } from "vuex";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: {},
  data() {
    return {
      files: "",
      user: {},
      page: {
        supply_name: "", //供销单位的名称
        concat: "", //联系人
        pager_offset: "0",
        pager_openset: "10",
      },
      picDialogVisible: false,
      picDialogVisible1: false,
      reportList: [],
      attachList: [],
      timer: "",
      add_time: "",
      end_time: "",
      infoUpload: [],
      loading: false,
      currentPage: 1,
      total: 0,
      tableData: [],
      goodsExist: [],
      supplyNotExist: [],
      batchError: [],
      activeName: "1",
      company_id: "",
      url: "",
      uploadVis: false,
      showViewer: false,
      showResult: false,
      dialogImageUrl: "",
      companyName: "",
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.page.end_time) {
            return time.getTime() > new Date(this.page.end_time).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      totalPrices: 0,
      quoUpdateList: [],
      activeNames: [],
      types: [],
    };
  },
  filters: {},
  computed: {
    ...mapState({
      carState: (state) => state.carManage.carState,
    }),
  },
  mounted() {
    this.page = Object.assign({}, this.page);
    this.user = local.get("user");
    this.page.company_id = String(local.get("company_id"));
    this.page.user_id = String(this.user.user_id);
    this.companyName = String(local.get("company_name"));
    this.currentPage = this.page.pager_offset / 10 + 1;
    this.init(this.page);
    api.get("/v1/wx/dic/qualification").then((res) => {
      if (res.data) {
        this.types = res.data;
      }
    });
  },
  methods: {
    beforeUpload1(file) {
      this.files = file;
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!extension2) {
        this.$message.warning("上传模板只能是 xlsx格式!");
        return;
      }
      if (!isLt10M) {
        this.$message.warning("上传模板大小不能超过 10MB!");
        return;
      }
      this.fileName = file.name;
      setTimeout(() => {
        this.submitUpload1();
      }, 500);
      return false; // 返回false不会自动上传
    },
    submitUpload1() {
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      let fileFormData = new FormData();
      fileFormData.append("code", "t_pathology_info_excel");
      fileFormData.append("description", "发货信息上传");
      fileFormData.append("file", this.files, this.fileName);
      //filename是键，file是值，就是要传的文件，test是要传的文件名
      fileFormData.append("company_id", this.page.company_id);
      fileFormData.append("user_id", this.page.user_id);

      // 执行上传excel
      let id = "";
      axios
        .uploadFile("/pc/receipt/importExcel?type=2", fileFormData)
        .then((resp) => {
          if (resp.code != 200) {
            this.$message.error("excel上传失败，请重新上传");
          }
          if (
            resp.data.goodsNotExist.length > 0 ||
            resp.data.supplyNotExist.length > 0 ||
            resp.data.info.length > 0
          ) {
            this.showResult = true;
            this.infoUpload = resp.data.info.map((v, i) => ({
              ...v,
              index: i,
              checked: false,
            }));
            this.goodsExist = resp.data.goodsNotExist;
            this.supplyNotExist = resp.data.supplyNotExist;
            this.$nextTick(function () {
              this.$refs.infoTable.toggleAllSelection();
            });
          } else {
          }
          this.init(this.page);
        })
        .catch((e) => {
          //console.debug(e);
          this.$message.error("excel上传失败，请重新上传");
        })
        .finally(() => {
          if (id) {
            // 触发生成订单实体数据
            this.generateBill(id);
          }
        });
    },
    openFile(index, index1, index2) {
      window.open(
        this.quoUpdateList[index].data[index1].list.filter((v) => v.file)[
          index2
        ].picUrl
      );
    },
    confirmInfo() {
      axios
        .post("/pc/receipt/confirmInfo", {
          receipts: this.infoUpload.filter((v) => v.checked),
          company_id: this.page.company_id,
        })
        .then((res) => {
          this.showResult = false;
          this.init(this.page);
        });
    },
    handleChecked(selection, row) {
      let checkedArr = selection.map((v) => v.index);
      this.infoUpload.forEach((v, i) => {
        if (checkedArr.length) {
          this.$set(v, "checked", checkedArr.includes(i));
        } else {
          this.$set(v, "checked", false);
        }
      });
    },
    handleCheckedAll(selection) {
      let checkedArr = selection.map((v) => v.index);
      this.infoUpload.forEach((v, i) => {
        if (checkedArr.length) {
          this.$set(v, "checked", checkedArr.includes(i));
        } else {
          this.$set(v, "checked", false);
        }
      });
    },
    getTotalPrices() {
      api
        .get(
          `/v1/pc/receipt-ship/totalPrices?companyId=${String(
            local.get("company_id")
          )}`,
          {
            type: 1,
            endTime: this.end_time,
            startTime: this.add_time,
            receipt_sn: this.page.receipt_sn,
            goods_name: this.page.goods_name,
            consignee_company_name: this.page.consignee_company_name,
            gtin: this.page.gtin,
          }
        )
        .then((res) => {
          this.totalPrices = res.data;
        });
    },
    add() {
      this.$router.push({ name: "ShippingAdd", query: { type: 1 } });
    },
    beforeUpload(file) {
      // console.log(file,'文件');
      this.files = file;
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt10M = file.size / 1024 / 1024 < 1000;
      if (!extension2) {
        this.$message.warning("上传模板只能是 xlsx格式!");
        return;
      }
      if (!isLt10M) {
        this.$message.warning("上传模板大小不能超过 1000MB!");
        return;
      }
      this.fileName = file.name;
      setTimeout(() => {
        this.submitUpload();
      }, 500);
      return false; // 返回false不会自动上传
    },
    success() {
      this.$message.success("上传成功");
    },
    showImage(item) {
      this.activeNames = [];
      api
        .get("/v1/wx/goods/quoUpdateList", {
          goodsId: item.goods_id,
          batchNumber: item.batch_number,
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data.length) {
              this.quoUpdateList = res.data.map((v) => {
                let data = {};
                let content = JSON.parse(v.content);
                this.types.forEach((item) => {
                  let dataItem = content.filter(
                    (val) => val.typeValue == item.value
                  );
                  if (dataItem.length) {
                    this.$set(data, item.value, {
                      title: item.label,
                      list: dataItem.map((listTtem) => {
                        return {
                          ...listTtem,
                          url: listTtem.picUrl,
                        };
                      }),
                    });
                  }
                });
                return {
                  ...v,
                  data,
                };
              });
            }
            this.reportList = [];
            this.picDialogVisible = true;
            if (item.qualification) {
              let temp = JSON.parse(item.qualification);
              for (var key in temp) {
                temp[key].map((m) => {
                  if (!m.file) {
                    this.reportList.push(m.pic_url ? m.pic_url : m.picUrl);
                  }
                });
              }
            }
          }
        });
    },
    closeViewer() {
      this.showViewer = false;
    },
    showImage1(item) {
      this.attachList = [];
      this.picDialogVisible1 = true;
      let temp = JSON.parse(item.real_pics);
      temp.map((m) => {
        this.attachList.push(m.url);
      });
    },
    // 上传excel
    submitUpload() {
      //console.log('上传'+this.files.name)
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      let fileFormData = new FormData();

      fileFormData.append("code", "t_pathology_info_excel");
      fileFormData.append("description", "收货批量上传");
      fileFormData.append("file", this.files, this.fileName);
      //filename是键，file是值，就是要传的文件，test是要传的文件名
      fileFormData.append("company_id", this.page.company_id);
      fileFormData.append("user_id", this.page.user_id);
      // 执行上传excel
      let id = "";
      axios
        .uploadFile("/pc/receipt/importExcel?type=0", fileFormData)
        .then((resp) => {
          if (resp.code != 200) {
            this.$message.error("excel上传失败，请重新上传");
          }
          if (
            resp.data.goodsNotExist.length > 0 ||
            resp.data.supplyNotExist.length > 0 ||
            resp.data.info.length > 0
          ) {
            this.showResult = true;
            this.infoUpload = resp.data.info.map((v, i) => ({
              ...v,
              index: i,
              checked: true,
            }));
            this.goodsExist = resp.data.goodsNotExist;
            this.supplyNotExist = resp.data.supplyNotExist;
            this.batchError = resp.data.batchError;

            this.$nextTick(function () {
              this.$refs.infoTable.toggleAllSelection();
            });
          } else {
          }
          this.init(this.page);
        })
        .catch((e) => {
          this.$message.error("excel上传失败，请重新上传");
        })
        .finally(() => {
          if (id) {
            // 触发生成订单实体数据
            this.generateBill(id);
          }
        });
    },
    change(index, val) {
      var that = this;
      if (val == null) val = "";
      if (index == 1) {
        that.add_time = val;
      }
      if (index == 2) {
        that.end_time = val;
      }
      //this.onSearch()
    },
    check(d_name) {
      axios.get("/pc/receipt/check", { down_name: d_name }).then((v) => {});
    },
    handlePictureCardPreview(url) {
      if (url) {
        this.dialogImageUrl = url;
        this.showViewer = true;
      } else {
        this.$message.warning("没有上传证件！");
      }
    },
    init(params) {
      axios.get("/pc/receipt/list", params).then((v) => {
        if (v.data.receipt_list.length) {
          this.tableData = v.data.receipt_list.map((item) => {
            if (item.receive_time) {
              let date = new Date(item.receive_time);
              item.receive_time = date.toLocaleString("zh-CN", {
                hour12: false,
              });

              // item.receive_time = item.receive_time
              //   .slice(0, 19)
              //   .replace("T", " ");
            }
            return item;
          });
        } else {
          this.tableData = v.data.receipt_list;
        }
        this.total = v.data.pager_count;
        this.getTotalPrices();
      });
    },
    // 搜索
    onSubmit() {
      this.currentPage = 1;
      this.page.pager_offset = "0";
      this.init(this.page);
    },
    // 分页
    currentChange(page) {
      this.currentPage = page;
      this.page.pager_offset = String((page - 1) * 10);
      this.init(this.page);
    },
    //批量导入
    batchAdd() {
      this.uploadVis = true;
    },
    downloadInfo(param) {
      axios
        .fileget("", { fileName: "receipt.xlsx" })
        .then((res) => {});
    },
    //编辑
    goUpdate(row) {
      this.$router.push({
        name: "WarehouseListAdd",
        query: { warehouse_id: row.id, nature: row.nature },
      });
    },
    handleStateChange(val, row) {
      const { id } = row;
      let car_state = val + "";
      axios.put("", { car_id: id + "", car_state }).then((response) => {
        this.init(this.page);
      });
    },
    //导出数据
    exportData() {
      const secounds = 5;
      let num = 0;
      this.timer = setInterval(() => {
        if (num < secounds) {
          num++;
          this.check("receipt");
        } else {
          clearInterval(this.timer);
          this.loading = false;
        }
      }, 2000);
      let statename;
      //console.debug(this.value);
      statename =
        this.companyName +
        this.add_time +
        (this.end_time ? "至" : "") +
        this.end_time +
        "的收货记录信息";
      let data = {
        fileName: statename,
        companyId: this.page.company_id,
        addTime: this.add_time,
        endTime: this.end_time,
      };
      // order/companyName/goodsName/gtin
      if (this.page.consignee_company_name) {
        data.companyName = this.page.consignee_company_name;
      }
      if (this.page.receipt_sn) {
        data.order = this.page.receipt_sn;
      }
      if (this.page.goods_name) {
        data.goodsName = this.page.goods_name;
      }
      if (this.page.gtin) {
        data.gtin = this.page.gtin;
      }
      axios.fileget("/pc/receipt/exportExcel", data).then((v) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.shopList {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-input-group__append .el-button--primary .el-icon-search {
    color: #fff;
  }
}

.demo-table-expand {
  font-size: 0;

  /deep/ .el-form-item__label {
    width: 90px;
    color: #99a9bf;
  }

  /deep/ .el-form-item__content {
    width: 50%;
  }

  /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 10%;
  }
}

.add-btn {
  flex: 0 0 200px;
}

.result-box::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}

.result-box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  // background: rgba(255, 255, 255, 0.8);
  background: #bbb;
  transition: color 0.2s ease;
  cursor: pointer;
}
/deep/ .el-dialog {
  border-radius: 10px;
}

/* 滚动条样式 */
.modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.jcb {
  justify-content: space-between;
}
/deep/.el-collapse-item__content {
  padding-bottom: 0 !important;
}
.section-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.file-background {
  background: #f0f7ff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;
  border: 1px solid #e3f2fd;
  cursor: pointer;
}

.ellipsis {
  text-align: left;
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
